import cloneDeep from 'lodash.clonedeep';
import set from 'lodash.set';
import get from 'lodash.get';

import types from './constants';
import { states } from '../../values/enums';
import Sorting from '../../util/sorting';
import reportReducers from '../reducers';

const dirs = Sorting.DIRS;
const benchmarkSorting = new Sorting({
  first_name: dirs.asc,
  score: dirs.asc,
});

const defaultReducer = (state, action) => (state)

const benchmarkSort = (state, action) => {
  let next = cloneDeep(state)
  let nextSorts;
  nextSorts = benchmarkSorting.run(
    get(next, 'report.data.scores'),
    action.sort,
    get(next, 'sorts', [])
  )
  set(next, 'report.data.scores', nextSorts.data)
  set(next, 'sorts', nextSorts.sorts)
  return next
}

const reportCacheSave = (state, action) => {
  let next = cloneDeep(state)
  const { updateKey } = action.payload
  const cache = cloneDeep(next.report.cachedData) || {}
  const classroomCache = cloneDeep(cache[action.payload.classroomId]) || {}
  next.report.cachedData = {
    ...next.report.cachedData,
    [action.payload.classroomId]: {
      ...classroomCache,
      [updateKey]: action.payload[updateKey]
    }
  }
  return next
}

const reportPending = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.PENDING})
  // reset the data to prevent rendering stale data when report is being fetched / refetched (changed class)
  set(next, 'report.activities', []);
  set(next, 'report.data', null)
  return next
}

const reportComplete = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.COMPLETE});
  set(next, 'report.activities', action.activities);
  set(next, 'report.data', action.report);
  if(action.report && action.report.scores) {
    let nextSorts;
    nextSorts = benchmarkSorting.run(
      action.report.scores, // items to sort
      action.sort || 'score', // what to sort by- defaults to "score"
      get(next, 'sorts', [{type: "score", dir: "desc"}]), // history of previous sorts, defaults to score/desc
      false, // whether to "flip" the sort from it's previous orientation
    );
    set(next, 'report.data.scores', nextSorts.data);
    set(next, 'sorts', nextSorts.sorts);
  }
  return next
}

const reportError = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.ERROR, data: action.error})
  return next
}

const actionReducer = Object.assign({
  [types.BENCHMARK_SORT]: benchmarkSort,
  [types.BENCHMARK_PENDING]: reportPending,
  [types.BENCHMARK_COMPLETE]: reportComplete,
  [types.BENCHMARK_ERROR]: reportError,
  [types.BENCHMARK_CACHE_SAVE]: reportCacheSave,
}, reportReducers);

export default (state = {}, action = {type: null}) => {
  const reducer = actionReducer[action.type] || defaultReducer
  return reducer(state, action)
}